import { get, post, patch, del, paramsToString } from './common.js';


// patch attachment view by attachment and user id
export function patchAttachmentView(attachment_id, data) {
    return patch(`/attachments/${attachment_id}/view/`, data);
}
